import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../components/LeadSource/LeadSource.css";

const LeadSource = ({ tokenStorage,openProfile,setOpenProfile,leadId }) => {
  const [leadDetailResponse, setLeadDetailResponse] = useState(null);
  const baseAPI = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETLeadSource?LeadSourceID=` +
            leadId,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    leadsourceid: leadId,
    LeadSource: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setFirstItem({
      leadsourceid: leadId,
    });
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddLeadSource`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      // Optionally, reset the form
      setFirstItem({
        LeadSource: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="leadSourceDetail">
        <form className="leadSource-form">
          
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>LeadSource</td>
            </tr>
           
                <tr key={firstItem.leadsourceid}>
                  <td>
                    <input name="LeadSource" value={firstItem.LeadSource} onChange={handleChange}/>
                  </td>
                </tr>
             
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addLeadSource-button">
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default LeadSource;
